import { IGetActivityLogResponse, IReturnableActivity } from '@/types/activity-log.types';
import { Get } from '../helpers';

export const GetMostRecentActivityLog = (channel: number, projectUuid: string): Promise<IGetActivityLogResponse> => {
  return Get({
    path: `/v4/admin/activity-log/${channel}/${projectUuid}?page=1&pageSize=1&published=true`,
  });
};

export interface LoadActivityLogOptions {
  cursor?: string | number;
  published?: boolean;
  pageSize?: number;
}
export const LoadActivityLog = (
  channel: number,
  eventUuid: string,
  opts?: LoadActivityLogOptions
): Promise<{ next: number | undefined; activities: IReturnableActivity[] }> => {
  const params = new URLSearchParams();
  if (opts?.cursor) {
    params.set('before', String(opts?.cursor));
  }
  if (opts?.published) {
    params.set('published', 'true');
  }
  if (opts?.pageSize) {
    params.set('pageSize', String(opts.pageSize));
  }

  return Get({
    path: `/v4/admin/activity-log/${channel}/${eventUuid}?${params.toString()}`,
  });
};
